<template>
    <div>
        <div class="row">
            <div class="col-md-6 form-group">
                <input type="text" class="form-control" v-model="firstName" placeholder="First Name" />
            </div>
            <div class="col-md-6 form-group">
                <input type="text" class="form-control" v-model="lastName" placeholder="Last Name" />
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 form-group">
                <input type="text" class="form-control" v-model="email" placeholder="Email" />
                <div class="error" v-show="formSent && !this.email">Please enter your email to receive answer.</div>
                <div class="error" v-show="formSent && !this.isEmailValid">Email is not in a correct format.</div>
            </div>
            <div class="col-md-6 form-group">
                <input type="text" class="form-control" v-model="phone" placeholder="Phone" />
            </div>
        </div>
        <div class="row">
            <div class="col form-group">
                <textarea class="form-control" v-model="message" placeholder="Message for us" rows="4"></textarea>
            </div>
        </div>

        <div class="row" v-show="this.success">
            <div class="col text-center text-success form-group">
                <p class="mb-0">
                    Message was successfully sent. One of our representatives will contact you shortly.               <br />
                    <b>Thank you!</b>
                </p>
            </div>
        </div>

        <div class="row mt-40 text-center">
            <div class="col">
                <button class="btn btn-primary" @click="sendCustomerContactRequest">
                    <span v-show="this.sending"><i class="fa fa-spinner fa-spin"></i></span> Send Message
                </button>
            </div>
        </div>
    </div>
</template>
<script>
    import ApiService from "../services/serviceApi"
    import { email } from 'vuelidate/lib/validators';

    export default {
        name: "CustomerContactForm",
        data() {
            return {
                email: '',
                phone: '',
                message: '',
                firstName: '',
                lastName: '',
                formSent: false,
                sending: false,
                success: false
            }
        },
        methods: {
            sendCustomerContactRequest: function () {
                this.formSent = true;
                this.success = false;
                if (!this.email || !email(this.email)) return;

                if (this.sending) return;
                this.sending = true;
                var contactModel =
                    {
                        apiKey: this.$store.state.configuration.apiKey,
                        firstName: this.firstName,
                        lastName: this.lastName,
                        email: this.email,
                        phone: this.phone,
                        message: this.message,
                    };
                ApiService.sendContactForm(contactModel).then((response) => {
                    this.sending = false;
                    this.success = true;
                }).catch(error => {
                    this.sending = false;
                });
            }
        },
        computed: {
            isEmailValid: function () { return email(this.email); },
        }
    }
</script>
<style>
    .contactFormModal .modal {
        background: rgba(0, 0, 0, 0.62);
    }
    .contactFormModal .modal-title {
        display: inline-block;
    }
</style>
